import { Box, styled, Button as MuiButton, Modal } from "@mui/material";

export const primaryBlue: string = `#003893`;

export const Block = styled(Box)<{ size?: string }>(({ size }) => ({
    display: size && size === `large` ? `inline-block` : `block`,
    width: size && size === `large` ? `calc(100% - 335px)` : `100%`,
}));

export const Button = styled(MuiButton)(() => ({
    padding: `4px 8px`,

    borderRadius: `10px`,
    backgroundColor: `#fff`,
    color: primaryBlue,
    border: `1px solid ${primaryBlue}`,
    cursor: `pointer`,
    fontSize: `18px`,
    margin: `20px auto 0`,
    display: `block`,

    a: {
        color: `inherit`,
        textDecoration: `none`,

        "&:visited": {
            color: `#d81e05`,
        },
    },
    "&.small": {
        margin: 0,
        padding: `4px 8px`,
        borderColor: `#c8c8c8`,
        boxShadow: `none`,
        color: `#000`,
        fontSize: `14px`,

        a: {
            color: `#000`,
        },
    },

    "&.small.primary": {
        borderColor: `#d81e05`,
        background: `#fff`,
    },

    "&:disabled": {
        color: `#ccc`,
    },
}));

export const NumberCircle = styled(Box)({
    height: `40px`,
    width: `40px`,
    borderRadius: `50%`,
    background: `linear-gradient(345deg, #007238, #00a651)`,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    color: `white`,
    fontWeight: 800,
    marginRight: `15px`,
    fontSize: 24,
    "& span": {
        marginTop: `3px`,
    },
});

export const AccountModal = styled(Modal)<{
    size?: string;
    enableScrollLock?: boolean;
    isOpen?: boolean;
    preventScroll?: boolean;
}>(({ size, sx = {} }) => ({
    width: `100%`,
    height: `100%`,
    position: `fixed`,
    zIndex: 999,
    "& .modalContent": {
        maxWidth: `800px`,
        minWidth: size === `small` ? `unset` : `500px`,
        position: `fixed`,
        marginTop: 0,
        top: `50%`,
        outline: `none`,
        left: `50%`,
        transform: `translate(-50%,-50%)`,
        zIndex: 333,
        height: size === `small` ? `100%` : `auto`,
        width: size === `small` ? `100%` : `auto`,
        ...sx,
    },
}));

export const GCardModal = styled(Modal)<{ size?: string; noMinSize: boolean }>(({ size, noMinSize, sx = {} }) => ({
    width: `100%`,
    height: `100%`,

    position: `fixed`,
    zIndex: 999,
    "& .modalContent": {
        maxWidth: `1200px`,
        minWidth: size !== `large` || noMinSize ? `unset` : `1000px`,
        position: `fixed`,
        minHeight: 500,
        marginTop: 0,
        top: `50%`,
        outline: `none`,
        left: `50%`,
        transform: `translate(-50%,-50%)`,
        zIndex: 333,
        height: size !== `large` ? `100%` : `auto`,
        width: size !== `large` ? `100%` : `auto`,
        display: `flex`,
        justifyContent: `space-around`,
        flexWrap: `wrap`,
        alignItems: `top`,
        ...sx,
    },
}));
